"use client";

import { useState } from "react";
import Comparison from "@/components/preview/comparison";
import DemoSwitch from "@/components/preview/demo-switch";

const LIGHT = {
  bg: "#ffffff",
  border: "#e4e4e4",
  buttonBg: "#171717",
  buttonText: "#ffffff",
  muted: "#737373",
  text: "#171717",
};

const DARK = {
  bg: "#1f1f1f",
  border: "#3f3f3f",
  buttonBg: "#f5f5f5",
  buttonText: "#171717",
  muted: "#9c9c9c",
  text: "#f5f5f5",
};

function MiniCard({ dark, tearing }: { dark: boolean; tearing: boolean }) {
  const theme = dark ? DARK : LIGHT;
  const transition = (value: string) => (tearing ? value : undefined);

  return (
    <div
      className="flex w-full max-w-52 select-none flex-col gap-1 rounded-xl border p-4"
      style={{
        backgroundColor: theme.bg,
        borderColor: theme.border,
        transition: transition("background-color 1200ms ease-out"),
      }}
    >
      <span
        className="font-medium text-sm"
        style={{
          color: theme.text,
          transition: transition("color 200ms ease-out"),
        }}
      >
        Appearance
      </span>
      <span
        className="text-xs"
        style={{
          color: theme.muted,
          transition: transition("color 700ms ease-out"),
        }}
      >
        Syncs with your system.
      </span>
      <div
        className="mt-2.5 flex h-7 w-fit items-center rounded-full px-3 font-medium text-xs"
        style={{
          backgroundColor: theme.buttonBg,
          color: theme.buttonText,
          transition: transition("background-color 400ms ease-out"),
        }}
      >
        Save
      </div>
    </div>
  );
}

export default function AnimationThemeTransitionsDemo() {
  const [dark, setDark] = useState(false);

  return (
    <Comparison
      bad={<MiniCard dark={dark} tearing />}
      footer={
        <DemoSwitch
          checked={dark}
          label="Dark mode"
          onCheckedChange={setDark}
        />
      }
      good={<MiniCard dark={dark} tearing={false} />}
      panelClassName="px-6 py-8"
      stackBelow="sm"
    />
  );
}
